import { fetchVerifyUserPassword } from 'alelo-logic/actions'

import {
  hasNumbers,
  validatePasswordLength,
  validateLetterLow,
  validateLetterUpper,
  validateLetterEspecial
} from 'alelo-logic/utils'

import { isEmpty, omitBy } from 'lodash'

import { setStepValidity, showStepBoxErrors } from '../StepBox/actions'

import { errors } from './data.json'

const {
  emptyConfirmPassword,
  emptyCurrentPassword,
  emptyNewPassword,
  lowerLetterNeeded,
  upperLetterNeeded,
  especialNeeded,
  newPasswordLength,
  notMatch,
  numberNeeded,
  samePassword
} = errors

function validateNewPassword(value, dispatch) {
  const error = {}

  if (!value || value.length === 0) {
    dispatch(showStepBoxErrors())
  } else {
    dispatch(showStepBoxErrors(true))

    if (!value || !validatePasswordLength(value)) {
      error.newPasswordLength = newPasswordLength
    }

    if (validateLetterLow(value)) {
      error.lowerLetterNeeded = lowerLetterNeeded
    }
    if (validateLetterUpper(value)) {
      error.upperLetterNeeded = upperLetterNeeded
    }

    if (!hasNumbers(value)) {
      error.numberNeeded = numberNeeded
    }

    if (validateLetterEspecial(value)) {
      error.especialNeeded = especialNeeded
    }

    dispatch(
      setStepValidity([
        !error.newPasswordLength,
        !error.lowerLetterNeeded,
        !error.upperLetterNeeded,
        !error.numberNeeded,
        !error.especialNeeded
      ])
    )
  }

  return error
}

function validatePassword(values = {}, props) {
  const { confirmPassword, currentPassword, newPassword } = values

  const error = {}
  const newPasswordErrors = validateNewPassword(newPassword, props.dispatch)
  const confirmPasswordErrors = newPassword !== confirmPassword && notMatch

  error.confirmPassword = isEmpty(confirmPassword) ? emptyConfirmPassword : confirmPasswordErrors
  error.currentPassword = isEmpty(currentPassword) && emptyCurrentPassword
  error.newPassword = isEmpty(newPassword) ? emptyNewPassword : newPasswordErrors
  error.newPassword =
    newPassword && newPassword === currentPassword ? samePassword : error.newPassword

  return omitBy(error, isEmpty)
}

const fetchCheckPassword = (val, dispatch, props) =>
  fetchVerifyUserPassword(props.values.currentPassword).catch(() => {
    throw { currentPassword: { wrongPassword: true } } // eslint-disable-line no-throw-literal
  })

export default {
  fetchCheckPassword,
  validateNewPassword,
  validatePassword
}



// WEBPACK FOOTER //
// ./src/app/modules/ChangePasswordForm/validatePassword.js